import { getHttpClient } from "@/http-client";

const baseUrl = "api/boss/applications";
export function createApplication(body) {
  return getHttpClient().post(baseUrl, { application: body });
}
